import { render, staticRenderFns } from "./m-data-tag.vue?vue&type=template&id=27d8d16c&scoped=true&"
import script from "./m-data-tag.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-data-tag.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-data-tag.vue?vue&type=style&index=0&id=27d8d16c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d8d16c",
  null
  
)

export default component.exports